Ext.define('SA.view.sidebar.data.DataSearchFacetBrowser', {
    alias: 'widget.data-search-facet-browser',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-data-search-facet-browser',

    initComponent() {
        this.callParent();

        this.ctMap = {};

        this.add(this.buildComponents());
    },

    buildComponents() {
        var cts = [],
            ctMap = this.ctMap;

        SA.data.AttributeFacets.getGroups().forEach(group => {
            var component, facetId;

            if (group.facets.length === 1) {
                let facet = group.facets[0];

                component = this.createFacetItem(facet);
                facetId = facet.id;
            }
            else {
                component = this.createFacetGroupItem(group);
                facetId = group.name;
            }

            ctMap[facetId] = component;

            if (component.isComponent) {
                cts.push(component);
            }
        });

        ctMap.ageRange = Ext.widget({xtype: 'data-facet-age-range'});

        this.incomeRangeUsa = Ext.widget({xtype: 'data-facet-income-range', country: 'USA'});
        this.incomeRangeCanada = Ext.widget({xtype: 'data-facet-income-range', country: 'CAN'});

        cts.splice(-3, 0, ctMap.ageRange, this.incomeRangeUsa, this.incomeRangeCanada);

        return cts;
    },

    clearAgeRange() {
        this.ctMap.ageRange.clear();
    },

    clearIncomeRange() {
        this.ctMap.incomeRange.clear();
    },

    createFacetGroupItem(group) {
        return Ext.widget({
            xtype: 'data-search-checkbox-group',
            title: group.name,

            listeners: {
                select: (checkboxes, values) => this.onChangeFacetGroupSelections(group, values)
            },

            sortFn(a, b) {
                var all = SA.data.AttributeFacets.all,
                    indexOf = category => all.findIndex(item => item.id === category);

                return indexOf(a.value) - indexOf(b.value);
            },

            valueToText(value) {
                return SA.data.AttributeFacets.getName(value);
            }
        });
    },

    createFacetItem(facet) {
        var facetId = facet.id,
            xtype = 'data-search-checkbox-group',
            electionsContestCheckboxOrder = ['President', 'U.S. Senate', 'U.S. House', 'Governor'],
            electionsPartyCheckboxOrder = ['Democrat', 'Republican', 'Other'],
            sortFn;

        switch (facetId) {
            case 'vendor':
                return {
                    removeFromSelection: vendor => {
                        var datasets = SA.model.Country.get(this.country).getDatasetIdsForVendor(vendor);

                        this.ctMap.dataset_series.removeFromSelection(datasets);
                    },

                    setValues: values => {
                        this.ctMap.dataset_series.setVendorValues(values);
                    }
                };

            case 'dataset_series':
                xtype = 'data-search-vendor-checkbox-group';
            break;

            case 'year':
                xtype = 'data-search-year-radio-group';
            break;
        }

        if (facet.id === 'elections_contest') {
            sortFn = (a, b) => electionsContestCheckboxOrder.indexOf(a.value) < electionsContestCheckboxOrder.indexOf(b.value) ? -1 : 1;
        }
        else if (facet.id === 'elections_party') {
            sortFn = (a, b) => electionsPartyCheckboxOrder.indexOf(a.value) < electionsPartyCheckboxOrder.indexOf(b.value) ? -1 : 1;
        }

        return Ext.widget({
            xtype,
            title: facet.name,
            ...(sortFn ? {sortFn} : {}),

            listeners: {
                select: (checkboxes, value) => this.onChangeFacetItemSelection(facetId, value)
            }
        });
    },

    deselectFacet(facet, value) {
        var group = SA.data.AttributeFacets.getGroup(facet),
            facetWidget = this.ctMap[group.name];

        if (group.facets.length > 1) {
            facetWidget.removeFromSelection(facet);
        }
        else {
            facetWidget.removeFromSelection(value);
        }
    },

    deselectVendor(vendor) {
        this.ctMap.vendor.removeFromSelection(vendor);
    },

    initEvents() {
        this.callParent();

        this.ctMap.ageRange.on('change', this.onChangeAgeRange, this);

        this.incomeRangeUsa.on('change', this.onChangeIncomeRange, this);
        this.incomeRangeCanada.on('change', this.onChangeIncomeRange, this);
    },

    onChangeAgeRange(range) {
        this.fireEvent('change:ageRange', range);
    },

    onChangeFacetGroupSelections(group, values) {
        var selections = group.facets.map(({id: facetId}) => {
            return {
                facetId,
                selected: values.includes(facetId)
            };
        });

        this.fireEvent('change:facetGroupSelections', selections);
    },

    onChangeFacetItemSelection(facetId, value) {
        this.fireEvent('change:facetItemSelection', facetId, value);
    },

    onChangeIncomeRange(range) {
        this.fireEvent('change:incomeRange', range);
    },

    removeCategory() {
        this.ctMap.Category.setSelected([]);
    },

    selectCategory(category) {
        var ctMap = this.ctMap,
            promotions = {
                age: ['ageRange', 'children'],
                business_counts: ['business_counts1'],
                consumer_behavior: ['consumer_behavior1'],
                education: ['education1'],
                gender: ['gender1'],
                health: ['health1'],
                households: ['Households', 'household_type'],
                housing: ['Housing'],
                income: ['Income', 'incomeRange'],
                jobs_employment: ['Jobs & Employment', 'job_title'],
                market_segments: ['lifestage_groups', 'social_groups'],
                other: ['other1'],
                population: ['Population'],
                race_ethnicity: ['race', 'ethnicity'],
                retail: ['retail1', 'spending_categories'],
                technology: ['technology1']
            }[category];

        ctMap.Category.setSelected([category]);

        if (promotions) {
            promotions = promotions.map(id => ctMap[id]);

            this.insert(1, promotions);
        }
    },

    setCountry(country) {
        this.country = country;

        this.ctMap.incomeRange = country === 'CAN' ? this.incomeRangeCanada : this.incomeRangeUsa;
    },

    setFacets(facets) {
        var ctMap = this.ctMap,
            groups = {},
            ranges = {age_min: 'ageRange', income_min: 'incomeRange'};

        SA.data.AttributeFacets.all.forEach(facet => {
            var id = facet.id,
                values = facets[id],
                group = facet.group;

            if (values) {
                if (group) {
                    group = groups[group] || (groups[group] = {});
                    group[id] = values['true'] || 0;
                }
                else {
                    ctMap[id].setValues(values);
                }
            }
        });

        for (let name in groups) {
            ctMap[name].mergeValues(groups[name]);
        }

        for (let name in ranges) {
            let values = facets[name],
                range, minMax;

            if (values) {
                range = ctMap[ranges[name]];
                minMax = range.getMinMax();

                range.setVisible(
                    !SA.Object.isEmpty(values) || minMax[0] != null || minMax[1] != null
                );
            }
        }
    },

    setYearFacet(year) {
        this.ctMap.year.setSelected(year);
    }
});
